function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.22222 16H20.7778C21.45 16 22 15.4 22 14.6667C22 13.9333 21.45 13.3333 20.7778 13.3333H1.22222C0.55 13.3333 0 13.9333 0 14.6667C0 15.4 0.55 16 1.22222 16ZM1.22222 9.33333H20.7778C21.45 9.33333 22 8.73333 22 8C22 7.26667 21.45 6.66667 20.7778 6.66667H1.22222C0.55 6.66667 0 7.26667 0 8C0 8.73333 0.55 9.33333 1.22222 9.33333ZM0 1.33333C0 2.06667 0.55 2.66667 1.22222 2.66667H20.7778C21.45 2.66667 22 2.06667 22 1.33333C22 0.6 21.45 0 20.7778 0H1.22222C0.55 0 0 0.6 0 1.33333Z",
  fill: "#373737"
});

function SvgHamburgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger-icon.d5493356.svg";
export { ForwardRef as ReactComponent };